import { render, staticRenderFns } from "./releaseSalaryPopup.vue?vue&type=template&id=52b45537&scoped=true"
import script from "./releaseSalaryPopup.vue?vue&type=script&lang=js"
export * from "./releaseSalaryPopup.vue?vue&type=script&lang=js"
import style0 from "./releaseSalaryPopup.vue?vue&type=style&index=0&id=52b45537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b45537",
  null
  
)

export default component.exports